import { defultSortBy, defultSortBySubmit } from '../components/sort-by';
import '../scss/collection.scss';
import { toggleDataActive } from '../utils/toggle-dataset';
import { rangeFilters } from '../components/filters-range';
import { initialInfinityScroll } from '../components/infinity-scroll';
import { mediaQuery } from '../utils/media-query';
import { onHandleSubmitSearch, handleInputsForm, removeFilters, filtersSearching, handleInputsFormClick, filtersScrollup } from '../components/filter';
import { initializeMesAlertsMethods } from '../components/mes-alerts';
import { lazyLoad } from '../utils/lazy-load';
import { $Q } from '../utils/query-selector';

mediaQuery('(max-width: 767px)', () => {
  handleInputsFormClick()
})

mediaQuery('(min-width: 768px)', () => {
  handleInputsForm()
  // filtersScrollup()
})

defultSortBy();
removeFilters()
filtersSearching()

lazyLoad($Q('#js-btn-mes-alets-open'), (observe) => {
  initializeMesAlertsMethods()
  observe.disconnect()
}, {
  rootMargin: '40px',
  threshold: 0,
})

mediaQuery('(max-width: 767px)', () => {
  toggleDataActive('#filter-open', '#filter', {
    overlay: true,
    type: 'side-cart',
    blockScroll: true
  });

  toggleDataActive('#filter-close', '#filter', {
    overlay: true,
    type: 'side-cart',
    blockScroll: true
  });
});

window.addEventListener('load', () => {
  initialInfinityScroll();
  rangeFilters();

  lazyLoad($Q('#js-text-seo-voir-plus'), (observe) => {
    toggleDataActive('#js-text-seo-voir-plus', '#js-text-seo-hidden');
    observe.disconnect()
  }, {
    rootMargin: '80px',
    threshold: 0,
  })
})
